<div class="tours1">
  <mat-tab-group #tab (selectChange)="tabChanged($event)">
    <mat-tab *ngIf="type === 'tour'" label="Itinerary Management">
      <ng-template mat-tab-label>
        <mat-icon>edit</mat-icon>
        Itinerary Management
      </ng-template>
      <div class="panel">
        <div class="panel-header">
          <h1>Create Itinerary</h1>
        </div>

        <ig-row>
          <ig-col [md]="6">
            <ig-field label="Title" [(ngModel)]="command.title" [isRequired]="true"
              [formControl]="createTourForm.get('title')">
            </ig-field>
            <mat-form-field class="full-width">
              <textarea matInput placeholder="Description" type="textArea" [(ngModel)]="command.description"
                [formControl]="createTourForm.get('description')">
              </textarea>
            </mat-form-field>
            <ig-button [isAsync]="true" [disabled]="createTourForm.invalid" color="accent" size="md"
              (trigger)="createTour($event)">
              Create
            </ig-button>
            <div *ngIf="showExceedTip" class="exceed-tip">
              Uh oh! You've reached the number of itineraries available for your account. If you
              need more itineraries, please contact
              <a target="_blank" href="https://itidigital.freshdesk.com/support/home">our team</a>.
              <span (click)="closeTip()">X</span>
            </div>
          </ig-col>
          <ig-col [md]="6">
            <ig-image-selector [command]="command" [selectedImageData]="selectedImageData"
              (onImageChanged)="onImageChange($event)">
            </ig-image-selector>
          </ig-col>
        </ig-row>
      </div>
      <div class="panel">
        <div class="panel-header">
          <h1>Itinerary Management</h1>
          <p>(Drag-and-drop and change the order your itineraries will appear on the widget)</p>
        </div>

        <ng-container *ngIf="!isLoadingTourList">
          <ig-list>
            <div header>
              <ig-list-column-header>
                <ig-row>
                  <ig-col [xs]="10" [md]="6">TITLE</ig-col>
                  <ig-col [xs]="2" [md]="2" class="hide-on-mobile">STATUS</ig-col>
                </ig-row>
              </ig-list-column-header>
            </div>
            <div body>
              <ig-list-item *ngFor="let tour of tours; let i = index" draggable [dragScope]="'list'"
                [dragEnabled]="!editMode[i]" droppable [dropScope]="'list'" [dragData]="tour"
                (onDrop)="onItemDrop($event, i)" [dragOverClass]="'drag-target-border'">
                <div *ngIf="!editMode[i]" (click)="edit(i, $event)">
                  <ig-row>
                    <ig-col [xs]="12" [md]="6">
                      <div (click)="edit(i, $event)">
                        {{ tour.title }}
                      </div>
                    </ig-col>
                    <ig-col [xs]="12" [md]="2">
                      <div class="status" (click)="edit(i, $event)">
                        <div class="badge" [class.badge-green]="tour.isActive" [class.badge-red]="!tour.isActive">
                          {{ tour.isActive ? "Active" : "Inactive" }}
                        </div>
                      </div>
                    </ig-col>
                    <ig-col [xs]="12" [md]="4">
                      <ig-row-action-buttons *ngIf="!isMobile">
                        <mat-icon matTooltip="Get Link" (click)="showLink(i, $event)">
                          web
                        </mat-icon>
                        <mat-icon matTooltip="Edit" (click)="edit(i, $event)"> edit </mat-icon>
                        <mat-icon matTooltip="Delete" (click)="deleteTour(i, $event)">
                          clear
                        </mat-icon>
                      </ig-row-action-buttons>
                      <div *ngIf="isMobile" class="action-buttons-mobile">
                        <mat-icon matTooltip="Edit" (click)="edit(i, $event)"> build </mat-icon>
                        <mat-icon matTooltip="Delete" (click)="deleteTour(i, $event)">
                          clear
                        </mat-icon>
                      </div>
                    </ig-col>
                  </ig-row>
                </div>

                <div *ngIf="editMode[i]" class="edit-tour">
                  <ig-row>
                    <ig-col [xs]="12" [md]="3" class="title-col">
                      <ig-image-selector #imageselector [command]="updateCommand" [isSmallIcon]="true"
                        (onUpload)="updateImage($event)" [selectedImageData]="editingImageData">
                      </ig-image-selector>

                      <div class="tour-title" matTooltip="{{ editingTour.title }}" (click)="showEditTitlePopup()">
                        <mat-icon>edit</mat-icon>
                        {{ editingTour.title }}
                      </div>

                      <ig-attraction-list #attractionlist [tour]="editingTour" [isDraggable]="!isPlanStarted"
                        (onready)="direction.ready()" [isShowAddtoMyTrip]="false"
                        (removeFromTrip)="redrawDirectionMap($event)"
                        (showInfoWindowOnMap)="direction.showInfoWindowByIndex($event)"
                        (reordered)="direction.drawFullRoute()"></ig-attraction-list>
                    </ig-col>
                    <ig-col [xs]="12" [md]="9" class="tour-map">
                      <div class="operation-pad" *ngIf="!isPlanStarted">
                        <ig-row>
                          <ig-col [xs]="6">
                            <ig-success-wrap #publish [delay]="1000" text="Succeed!">
                              <mat-slide-toggle name="slide" [color]="'green'" [(ngModel)]="editingTour.isActive"
                                (change)="publishOrDePublishTour(editingTour)">
                                Publish
                              </mat-slide-toggle>
                            </ig-success-wrap>
                          </ig-col>
                          <ig-col [xs]="5" class="back" (click)="cancelEdit(i)">
                            <mat-icon>chevron_left</mat-icon>
                            Back
                          </ig-col>
                        </ig-row>
                      </div>
                      <ig-direction-plan #direction type="tour" [tour]="editingTour" [canSetDefaultTravelMode]="true"
                        (onStart)="startPlan()" (onEnd)="stopPlan()"></ig-direction-plan>
                    </ig-col>
                  </ig-row>
                </div>
              </ig-list-item>
              <div *ngIf="!tours || !tours.length" class="empty-list">No Content Here...</div>
              <div class="tour-mask" *ngIf="isLoading"></div>
              <ig-spinner class="tour-spinner" *ngIf="isLoading"></ig-spinner>
            </div>
          </ig-list>
        </ng-container>

        <ig-spinner *ngIf="isLoadingTourList" class="m-t-3"></ig-spinner>
      </div>
    </mat-tab>
    <mat-tab label="Images">
      <ng-template mat-tab-label>
        <mat-icon>build</mat-icon>
        Images
      </ng-template>
      <div class="flex">
        <div *ngIf="type === 'trip'" class="panel left" left>
          <div class="panel-header">
            <h1>Trip Planner Home Image</h1>
          </div>

          <mat-radio-group class="custom-edit-item radio-group" [(ngModel)]="tpHomeImage.isDefault">
            <mat-radio-button [value]="true"> Use default </mat-radio-button>
            <mat-radio-button [value]="false"> Customize </mat-radio-button>
          </mat-radio-group>
          <div class="m-t-3">
            <ig-image-cropper *ngIf="!tpHomeImage.isDefault" class="m-t-3" #tpHomeImgCropper
              [imageData]="tpHomeImageData" [cropperSettings]="cropperSettingsForPDF"></ig-image-cropper>
          </div>

          <ig-button size="md" (trigger)="saveTPHomeImage($event)" [isAsync]="true">save</ig-button>
        </div>

        <div *ngIf="type === 'tour'" class="panel" middle>
          <div class="panel-header">
            <h1>PDF Itinerary Header Image</h1>
          </div>

          <mat-radio-group class="custom-edit-item radio-group"
            [(ngModel)]="PDFSettings.pdf.headerImage.tour.isDefault">
            <mat-radio-button [value]="true"> Use default </mat-radio-button>
            <mat-radio-button [value]="false"> Customize </mat-radio-button>
          </mat-radio-group>

          <div class="m-t-3">
            <ig-image-cropper *ngIf="!PDFSettings.pdf.headerImage.tour.isDefault" class="m-t-3" #tourImgCropper
              [imageData]="PDFSettingImageCorperData.tour" [cropperSettings]="cropperSettingsForPDF"></ig-image-cropper>
          </div>

          <ig-button size="md" (trigger)="savePDFTourHeaderImage($event)" [isAsync]="true">save</ig-button>
        </div>

        <div *ngIf="type === 'tour'" class="panel" middle>
          <div class="panel-header">
            <h1>Itinerary Sidebar Image</h1>
          </div>

          <mat-radio-group class="custom-edit-item radio-group" [(ngModel)]="tourSidebarImage.isDefault">
            <mat-radio-button [value]="true"> Use default </mat-radio-button>
            <mat-radio-button [value]="false"> Customize </mat-radio-button>
          </mat-radio-group>

          <div class="m-t-3">
            <ig-image-cropper *ngIf="!tourSidebarImage.isDefault" class="m-t-3" #tourSidebarImgCropper
              [imageData]="tourSidebarImageData" [cropperSettings]="cropperSettingsForTourSidebar"></ig-image-cropper>
          </div>

          <ig-button size="md" (trigger)="saveTourSidebarImage($event)" [isAsync]="true">save</ig-button>
        </div>

        <div *ngIf="type === 'trip'" class="panel" right>
          <div class="panel-header">
            <h1>PDF User Trip Header Image</h1>
          </div>

          <mat-radio-group class="custom-edit-item radio-group"
            [(ngModel)]="PDFSettings.pdf.headerImage.trip.isDefault">
            <mat-radio-button [value]="true"> Use default </mat-radio-button>
            <mat-radio-button [value]="false"> Customize </mat-radio-button>
          </mat-radio-group>

          <div class="m-t-3" [class.hide]="PDFSettings.pdf.headerImage.trip.isDefault">
            <ig-image-cropper #tripImgCropper [imageData]="PDFSettingImageCorperData.trip"
              [cropperSettings]="cropperSettingsForPDF"></ig-image-cropper>
          </div>

          <ig-button size="md" (trigger)="savePDFTripHeaderImage($event)" [isAsync]="true">save</ig-button>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="type === 'trip'" label="Design">
      <ng-template mat-tab-label>
        <mat-icon>web</mat-icon>
        Design
      </ng-template>

      <div class="flex">
        <div class="panel half-width m-r-1">
          <div class="panel-header">
            <h1>Place Details Style</h1>
          </div>

          <ng-container *ngIf="!isLoadingDetailsStyle">
            <mat-radio-group class="radio-group" [(ngModel)]="detailsStyle" (ngModelChange)="setDetailsStyle()">
              <mat-radio-button [value]="'float'"> Side Floating </mat-radio-button>
              <mat-radio-button [value]="'popup'"> Popup </mat-radio-button>
            </mat-radio-group>

            <div class="panel-preview">
              <p>Preview</p>
              <div class="flex">
                <ng-container *ngIf="detailsStyle === 'float'">
                  <div class="relative">
                    <img [src]="detailsPreview" alt="" height="280px" />
                    <div #sidefloat style="
                        position: absolute;
                        top: 39px;
                        left: 333px;
                        height: 241px;
                        z-index: 2;
                        opacity: 0;
                        transition: 0.3s;
                      ">
                      <img [src]="sideFloatView" height="100%" alt="" />
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="detailsStyle === 'popup'">
                  <div class="relative" style="width: 100%">
                    <img [src]="detailsPreview" alt="" width="50%" height="280px" />
                    <div #popup style="
                        position: absolute;
                        top: 60px;
                        left: 0;
                        width: 50%;
                        height: 260px;
                        z-index: 2;
                        opacity: 0;
                        transition: 0.3s;
                      ">
                      <img [src]="popupView" width="100%" height="100%" alt="" />
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
          <ig-spinner *ngIf="isLoadingDetailsStyle"></ig-spinner>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngIf="type === 'trip'" label="Regions Feature">
      <ng-template mat-tab-label>
        <mat-icon>widgets</mat-icon>
        Regions Feature
      </ng-template>

      <ig-region-management></ig-region-management>
    </mat-tab>

    <mat-tab label="V3">
      <ng-template mat-tab-label>
        <mat-icon>stars</mat-icon>
        V3
      </ng-template>

      <ng-container *ngIf="type === 'trip' && !isLoadingV3Settings && aiSettings && tpSettings">
        <div class="panel">
          <div class="panel-header">
            <h1>AI Suggested Itineraries</h1>
          </div>

          <p>Default AI Suggested Itineraries</p>
          <ig-field [formControl]="editTourForm.get('v3DefaultAISuggestedItinerary1')" placeholder="Suggest a one-day itinerary in {{
              aiSettings.travelBuddy.cityName || 'Savannah, GA'
            }}."></ig-field>
          <ig-field [formControl]="editTourForm.get('v3DefaultAISuggestedItinerary2')" placeholder="Suggest a foodie itinerary in {{
              aiSettings.travelBuddy.cityName || 'Savannah, GA'
            }}."></ig-field>
          <ig-field [formControl]="editTourForm.get('v3DefaultAISuggestedItinerary3')" placeholder="Suggest a kid-friendly itinerary in {{
              aiSettings.travelBuddy.cityName || 'Savannah, GA'
            }}."></ig-field>

          <ig-button (trigger)="saveV3Settings($event)">Save</ig-button>
        </div>

        <div class="panel ig-mobile-landing">
          <div class="panel-header">
            <h1>Desktop View Page</h1>

            <div class="flex justify-between" style="gap: 60px">
              <div style="width: 400px;" class="flex flex-col gap-2">
                <p>Number of columns</p>
                <mat-select [(ngModel)]="tpSettings.desktopPage.listColumns">
                  <mat-option [value]="2">2</mat-option>
                  <mat-option [value]="3">3</mat-option>
                  <mat-option [value]="4">4</mat-option>
                </mat-select>
                <p>List margin</p>
                <mat-select [(ngModel)]="tpSettings.desktopPage.listMargin">
                  <mat-option [value]="0">0</mat-option>
                  <mat-option [value]="4">4</mat-option>
                  <mat-option [value]="8">8</mat-option>
                  <mat-option [value]="12">12</mat-option>
                  <mat-option [value]="16">16</mat-option>
                </mat-select>
              </div>

              <div class="ig-tp-preview" style="border:1px solid gray;flex-grow:1;min-height: 500px;">
                <div class="flex full-height">
                  <div style="width: 18%;height:calc(100% - 24px);padding:12px;background-color: #e1ecf7;">
                    <p>Events</p>
                    <p>Places</p>
                    <p>Itineraries</p>
                    <p>My Trips</p>
                  </div>
                  <div class="flex flex-col flex-grow">
                    <div style="background-color: white;padding:12px 24px">
                      <p style="color:lightgray;width:100%;text-align: right;">Login to create your trips</p>
                    </div>
                    <div class="flex">
                      <div style="background-color: #f3f6fc;width:67%"
                        [ngStyle]="{'width':tpSettings.desktopPage.listColumns===4?'60%':'50%'}">
                        <div style="border-bottom:1px solid lightgray;padding:4px 12px;color:lightgray">Search</div>
                        <div style="display: grid;gap:8px;padding:12px;max-height: 400px;overflow:auto;"
                          [ngStyle]="{'grid-template-columns': 'repeat(' + tpSettings.desktopPage.listColumns + ', minmax(0, 1fr))'}">
                          <div *ngFor="let card of [0,1,2,3,4,5,6,7,8,9,10]" class="flex flex-col"
                            style="background-color: white;border-radius: 8px"
                            [ngStyle]="{'padding': tpSettings.desktopPage.listMargin + 'px'}">
                            <img src="assets/imgs/new_placeholder_image.jpg" alt=""
                              style="aspect-ratio: 7/5;border-radius: 8px;">
                            <p style="margin-left:8px;font-size: 12px;">Place Name</p>
                            <div class="flex" style="gap:1px;font-size: 8px;padding:0 8px;" [ngStyle]="{'padding': tpSettings.desktopPage.listMargin === 0 ? '8px' : '0', 
                                'width': tpSettings.desktopPage.listMargin === 0 ? 'calc(100% - 16px)' : '100%'}">
                              <div style="background-color: #60a5fa;color:white;flex:1;text-align: center;">DETAILS
                              </div>
                              <div style="background-color: #60a5fa;color:white;flex:1;text-align: center;">+ My TRIP
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex justify-center items-center"
                        [ngStyle]="{'width':tpSettings.desktopPage.listColumns===4?'33%':'50%'}">
                        <img src="https://iti-images.s3.us-east-1.amazonaws.com/imgs/map.jpg"
                          class="full-width full-height" style="max-height: 456px;" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ig-button (trigger)="saveV3Settings($event)" [isAsync]="true">Save</ig-button>
          </div>
        </div>

        <div class=" panel ig-mobile-landing">
          <div class="panel-header">
            <h1>Mobile View Landing Page</h1>
          </div>

          <div class="flex gap-2">
            <div *ngIf="tpSettings" style="width: 60%">
              <div>
                <p>Banner Text 1</p>
                <ig-field [formControl]="editTourForm.get('mobileBannerText1')"
                  [(ngModel)]="tpSettings.mobileLandingPage.bannerText1"></ig-field>
                <p>Banner Text 2</p>
                <ig-field [formControl]="editTourForm.get('mobileBannerText2')"
                  [(ngModel)]="tpSettings.mobileLandingPage.bannerText2"></ig-field>

                <div>Banner image URL</div>
                <div class="flex gap-2">
                  <ig-field [formControl]="editTourForm.get('mobileBannerImage')"
                    [(ngModel)]="tpSettings.mobileLandingPage.bannerImage"></ig-field>
                  <div class="or">Or</div>
                  <ig-image-selector label="Upload" [command]="command" [updateLabel]="''"
                    (onImageChanged)="onMobileImageChange($event, 'banner')" [selectedImageData]="bannerImgData"
                    [class.img-selected]="!!bannerImgData">
                  </ig-image-selector>
                </div>
              </div>

              <div>
                <div>Event image URL</div>
                <div class="flex gap-2">
                  <ig-field [formControl]="editTourForm.get('mobileEventImage')"
                    [(ngModel)]="tpSettings.mobileLandingPage.eventImage"></ig-field>
                  <div class="or">Or</div>
                  <ig-image-selector label="Upload" [command]="command" [updateLabel]="''"
                    (onImageChanged)="onMobileImageChange($event, 'event')" [selectedImageData]="eventImgData"
                    [class.img-selected]="!!eventImgData">
                  </ig-image-selector>
                </div>
              </div>
              <div>
                <div>Place image URL</div>
                <div class="flex gap-2">
                  <ig-field [formControl]="editTourForm.get('mobilePlaceImage')"
                    [(ngModel)]="tpSettings.mobileLandingPage.placeImage"></ig-field>
                  <div class="or">Or</div>
                  <ig-image-selector label="Upload" [command]="command" [updateLabel]="''"
                    (onImageChanged)="onMobileImageChange($event, 'place')" [selectedImageData]="placeImgData"
                    [class.img-selected]="!!placeImgData">
                  </ig-image-selector>
                </div>
              </div>
              <div>
                <div>Itinerary image URL</div>
                <div class="flex gap-2">
                  <ig-field [formControl]="editTourForm.get('mobileItineraryImage')"
                    [(ngModel)]="tpSettings.mobileLandingPage.itineraryImage"></ig-field>
                  <div class="or">Or</div>
                  <ig-image-selector label="Upload" [command]="command" [updateLabel]="''"
                    (onImageChanged)="onMobileImageChange($event, 'itinerary')" [selectedImageData]="itineraryImgData"
                    [class.img-selected]="!!itineraryImgData">
                  </ig-image-selector>
                </div>
              </div>
              <div>
                <div>Trip image URL</div>
                <div class="flex gap-2">
                  <ig-field [formControl]="editTourForm.get('mobileTripImage')"
                    [(ngModel)]="tpSettings.mobileLandingPage.tripImage"></ig-field>
                  <div class="or">Or</div>
                  <ig-image-selector label="Upload" [command]="command" [updateLabel]="''"
                    (onImageChanged)="onMobileImageChange($event, 'trip')" [selectedImageData]="tripImgData"
                    [class.img-selected]="!!tripImgData">
                  </ig-image-selector>
                </div>
              </div>
            </div>
            <div class="tp-mobile-preview">
              <div class="relative">
                <div class="ig-tp-mobile-banner" [ngStyle]="{
                    backgroundImage:
                      'url(&quot;' +
                      (tpSettings.mobileLandingPage.bannerImage
                        ? tpSettings.mobileLandingPage.bannerImage
                        : bannerImgData || defaultBannerImage) +
                      '&quot;)'
                  }">
                  <div class="text-center">
                    <b class="">{{ tpSettings.mobileLandingPage.bannerText1 || hubName }}</b>
                    <b class="">{{ tpSettings.mobileLandingPage.bannerText2 || "TRIP PLANNER" }}</b>
                  </div>
                </div>

                <div class="ig-tp-mobile-ai">
                  <p class="ig-tp-start-btn">Start by creating your first trip</p>
                  <hr />
                  <p class="ig-tp-start-tip">Need ideas? Try out AI suggested itineraries</p>
                  <div class="flex gap-2 overflow-hidden">
                    <div class="ai-questions">
                      {{ editTourForm.get("v3DefaultAISuggestedItinerary1")?.value }}
                    </div>
                    <div class="ai-questions">
                      {{ editTourForm.get("v3DefaultAISuggestedItinerary2")?.value }}
                    </div>
                    <div class="ai-questions">
                      {{ editTourForm.get("v3DefaultAISuggestedItinerary3")?.value }}
                    </div>
                  </div>
                </div>

                <section style="margin-top: 60px">
                  <b>Events to Explore</b>
                  <img [src]="
                      tpSettings.mobileLandingPage.eventImage
                        ? tpSettings.mobileLandingPage.eventImage
                        : eventImgData || defaultEventImage
                    " />
                </section>
                <section>
                  <b>Places to Visit</b>
                  <img [src]="
                      tpSettings.mobileLandingPage.placeImage
                        ? tpSettings.mobileLandingPage.placeImage
                        : placeImgData || defaultPlaceImage
                    " />
                </section>
                <section>
                  <b>Suggested Itineraries</b>
                  <img [src]="
                      tpSettings.mobileLandingPage.itineraryImage
                        ? tpSettings.mobileLandingPage.itineraryImage
                        : itineraryImgData || defaultItineraryImage
                    " />
                </section>
                <section>
                  <b>My Trips</b>
                  <img [src]="
                      tpSettings.mobileLandingPage.tripImage
                        ? tpSettings.mobileLandingPage.tripImage
                        : tripImgData || defaultTripImage
                    " />
                </section>
              </div>
            </div>
          </div>

          <ig-button (trigger)="saveV3Settings($event)" [isAsync]="true">Save</ig-button>
        </div>
      </ng-container>
      <div *ngIf="type === 'tour'">
        <div class="panel m-r-1">
          <div class="panel-header">
            <h1>Itinerary Builder V3</h1>
          </div>

          <div class="">
            <p>Please build your itineraries in the new Itinerary Builder V3</p>
            <ig-button style="width: 300px; height: 60px; margin: 16px 0 12px" (trigger)="openNewItineraryBuilder()">
              Open New Itinerary Builder
            </ig-button>
          </div>
        </div>
      </div>
      <ig-spinner *ngIf="isLoadingV3Settings"></ig-spinner>
    </mat-tab>
  </mat-tab-group>
</div>

<div #tourmobile *ngIf="isMobile" class="tours tour-mobile-detail">
  <ig-row *ngIf="isShowMobileEdit">
    <ig-col [xs]="12" [md]="3" class="title-col">
      <div class="operation-pad" [class.operation-pad-disabled]="isPlanStarted">
        <ig-row>
          <ig-col [xs]="6">
            <ig-success-wrap #publish [delay]="1000" text="Succeed!">
              <mat-slide-toggle name="slide" [color]="'green'" [(ngModel)]="editingTour.isActive"
                (change)="publishOrDePublishTour(editingTour)">
                Publish
              </mat-slide-toggle>
            </ig-success-wrap>
          </ig-col>
          <ig-col [xs]="5" class="back" (click)="cancelEdit()">
            <mat-icon>chevron_left</mat-icon>
            Back
          </ig-col>
        </ig-row>
      </div>

      <ig-image-selector #imageselector [command]="updateCommand" [isSmallIcon]="true" (onUpload)="updateImage($event)"
        [selectedImageData]="editingImageData">
      </ig-image-selector>

      <ig-direction-plan #directionmobile [tour]="editingTour" (onStart)="startPlan()"
        (onEnd)="stopPlan()"></ig-direction-plan>

      <div class="tour-title" matTooltip="{{ editingTour.title }}" (click)="showEditTitlePopup()">
        <mat-icon>edit</mat-icon>
        {{ editingTour.title }}
      </div>

      <ig-attraction-list #attractionlist [tour]="editingTour" [isDraggable]="!isPlanStarted"
        (onready)="directionmobile.ready()" [isShowAddtoMyTrip]="false"
        (showInfoWindowOnMap)="directionmobile.showInfoWindowByIndex($event)"
        (reordered)="directionmobile.drawFullRoute()"></ig-attraction-list>
    </ig-col>
  </ig-row>

  <ig-page-spinner #mobileeditspinner></ig-page-spinner>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/tours/tour.component.html